import React, { ReactElement, ReactNode, useState } from 'react';
import { ViewPager } from 'components/view-pager';
import LeftArrowIcon from 'assets/svg/arrow-narrow-left.svg';
import { PlaceholderWrapper, PlaceholderItem } from '../carousel/styled';
import { ListingCardPlaceholder as Placeholder } from 'components/cards/listing/ListingCardPlaceholder';
import { Arrow, ArrowsContainer, ArrowsWrapper, Wrapper, MadadPagerContainer } from './styled';
import { useScreenBreakpoint } from 'consts/breakpoints';

export interface MadadAreasCarouselProps {
  hasArrows?: boolean;
  title?: ReactNode;
  children: ReactElement[];
  isLoading?: boolean;
  onArrowClick?: (direction: 'right' | 'left') => void;
  onSwipe?: (direction: 'right' | 'left') => void;
}

const VISIBLE_ITEMS_PER_SLIDE = 1;

export const MadadAreasCarousel: React.FC<MadadAreasCarouselProps> = props => {
  const {
    hasArrows,
    title,
    children,
    isLoading,
    onArrowClick,
    onSwipe,
  } = props;
  const [ activeCarouselSlide, setActiveCarouselSlide ] = useState(0);
  const isMobile = useScreenBreakpoint() === 1;

  const onPrevClick = () => {
    setActiveCarouselSlide((prev) => prev - 1);
    if (onArrowClick) onArrowClick('right');
  };

  const onNextClick = () => {
    setActiveCarouselSlide(activeCarouselSlide + 1);
    if (onArrowClick) onArrowClick('left');
  };

  const arrayLength = hasArrows ? 4 : 2;
  const gap = isMobile ? 16 : 24;

  return (
    <Wrapper>
      {isLoading ? (
        <PlaceholderWrapper>
          {new Array(arrayLength).fill(null).map((_, idx) => (
            <PlaceholderItem key={idx}>
              <Placeholder />
            </PlaceholderItem>
          ))}
        </PlaceholderWrapper>
      ) : (
        <>
          <ArrowsContainer>
            {title}
            {hasArrows ? (
              <>
                <ArrowsWrapper>
                  <Arrow data-auto="left-slide-btn" dir="prev" disabled={activeCarouselSlide === 0} onClick={onPrevClick}>
                    <LeftArrowIcon />
                  </Arrow>
                  <Arrow data-auto="right-slide-btn" dir="next" disabled={activeCarouselSlide === children.length - VISIBLE_ITEMS_PER_SLIDE} onClick={onNextClick}>
                    <LeftArrowIcon />
                  </Arrow>
                </ArrowsWrapper>
              </>
            ) : null}
          </ArrowsContainer>
          <MadadPagerContainer>
            <ViewPager
              slideIndex={activeCarouselSlide}
              onSlideIndexChange={setActiveCarouselSlide}
              verticalAlign="flex-start"
              isRTL
              gap={gap}
              onSwipeLeft={onSwipe ? () => onSwipe('right') : undefined}
              onSwipeRight={onSwipe ? () => onSwipe('left') : undefined}
            >
              {children}
            </ViewPager>
          </MadadPagerContainer>
        </>
      )}
    </Wrapper>
  );
};
